export default __webpack_public_path__ + "static/media/closet_cav_spot_FINAL.c5b289c2.png";